var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensePlateBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0501 39H7.94972C6.87299 39 6 38.1027 6 36.9957V27.0043C6 25.8974 6.87299 25 7.94972 25H56.0501C57.127 25 58 25.8974 58 27.0043V36.9957C58 38.1027 57.127 39 56.0501 39Z",
    stroke: "#193232",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.5C33 34.3284 32.3284 35 31.5 35C30.6715 35 30 34.3284 30 33.5V30.5C30 29.6716 30.6715 29 31.5 29C32.3284 29 33 29.6716 33 30.5V33.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33.5C45 34.3284 44.3284 35 43.5 35C42.6715 35 42 34.3284 42 33.5V30.5C42 29.6716 42.6715 29 43.5 29C44.3284 29 45 29.6716 45 30.5V33.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30.5C54 31.3284 53.3284 32 52.5 32C51.6715 32 51 31.3284 51 30.5C51 29.6716 51.6715 29 52.5 29C53.3284 29 54 29.6716 54 30.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33.5C54 34.3284 53.3284 35 52.5 35C51.6715 35 51 34.3284 51 33.5C51 32.6716 51.6715 32 52.5 32C53.3284 32 54 32.6716 54 33.5Z",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0472 30.125C35.2137 29.4781 35.8009 29 36.5 29C37.3283 29 38 29.6717 38 30.5001C38 31.3285 37.3283 32.0001 36.5 32.0001C35.6715 32.0001 35 32.6717 35 33.4999V35H38",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 32C25.3284 32 26 32.6716 26 33.5C26 34.3284 25.3284 35 24.5 35H23V29H24.5C25.3284 29 26 29.6716 26 30.5C26 31.3284 25.3284 32 24.5 32H23",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 32C20.3284 32 21 32.6716 21 33.5C21 34.3284 20.3284 35 19.5 35H18V29H19.5C20.3284 29 21 29.6716 21 30.5C21 31.3284 20.3284 32 19.5 32H18",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30.125L48 29V34.8711",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9336 34.9048H49.255",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4287 25V38.6191",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlateBig);
export default __webpack_public_path__ + "static/media/license-plate-big.3364725ef8ed8e2ba22b85da6ae1c6b6.svg";
export { ForwardRef as ReactComponent };